import { AppDownloadMainInfo } from './AppDownloadMainInfo';

export default AppDownloadMainInfo;
